<template>
<div class="coupons"><h3>{{ $$FormData.title || '积分兑换券/码' }}</h3><div class="coupon"><strong>¥10</strong><div>积分兑换优惠券<p>100积分 · 满100元可用</p></div><span :style="{background: $$FormData.theme_color || '#202020'}">兑换</span></div><small>当前接入现有积分兑券活动，不新建独立兑换码商品</small></div>
</template>
<script>
export default { name: 'PointsCouponsPreview' }
</script>
<style scoped>
.summary { padding: 22px 12px; color: #fff; display: flex; justify-content: space-between; font-size: 12px; }
.summary strong { margin-left: 12px; font-size: 22px; }
.goods,.coupons { background: #fff; padding: 12px; font-size: 12px; }
h3 { margin: 0 0 14px; font-size: 16px; }
p,small { color: #999; } small { font-size: 10px; }
.card,.coupon { display: flex; gap: 12px; align-items: center; padding: 16px 0; border-bottom: 1px solid #eee; }
.card i { font-size: 36px; color: #b69d70; }
.card span,.coupon span { margin-left: auto; padding: 5px 8px; border-radius: 4px; background: #202020; color: #fff; }
.coupon strong { font-size: 26px; color: #b69d70; }
.row-two { display: flex; gap: 8px; }.row-two .card { width: 50%; flex-direction: column; align-items: flex-start; }
</style>
